import React, { useCallback, useRef } from 'react';
import { Grid, Card, CardContent, Typography, Button, CardActions } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import strings from "../Globalization/index";
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import { DeleteResyncDataModel } from '../AppGrid/DeleteResyncDataTable';
import { useUniqueEffect, useSetState } from '../hooks';
import utils from '../util';
import ConfirmDialog from '../components/confirm';
import { usePrerequisites } from '../contexts/Prerequisites';
import { getSearchParams } from '../contexts/Prerequisites/RoutesGuard';

const DeleteResyncDataGird = DeleteResyncDataModel.createGridBase();
const initalState = {
	statusTable: false,
	confirmTable: false,
	confirmDialogOpen: false,
	fileRequestStatus: null,
	deleteProfileStatus: null,
	isDisabled: false
}
const HeaderDescription = () => {
	return (
		<Card sx={{ marginBottom: 1 }}>
			<CardContent>

				<Typography variant="h5" component="div" style={{ color: 'red' }}>
					{strings.Warning || 'Warning'}
				</Typography>
				<Typography variant="body1" >{
					(strings.DeleteScopeWarrings || '').split('\n').map((line, index) => (
						<React.Fragment key={index}>
							{line}
							<br />
						</React.Fragment>
					))
				}</Typography>
			</CardContent>
		</Card>
	);
};
const BackButton = () => {
	return (<Button variant='contained' startIcon={<ArrowBackIcon />} component={Link} to={`/interfaceConfig`} >{strings.Back}</Button>)
}

const EndoProfile = () => {
	const [, setBreadcrumbs] = useBreadcrumbs();
	const searchParams = getSearchParams()
	const interFaceType = searchParams.get('interFaceType');
	const [{ socketClient },] = usePrerequisites();
	const [state, setState] = useSetState(initalState);
	const selectedRowRef = useRef({});

	const handleRequestFile = (response) => {
		if (!response.success) {
			return;
		}
		setState({ fileRequestStatus: true });
	}

	const handleDeleteEndoProfile = (response) => {
		if (!response.success) {
			return;
		}
		setState({ deleteProfileStatus: true });
		const clientName = selectedRowRef.current?.ClientName;
		const serialNumber = selectedRowRef.current?.SerialNumber;
		if (clientName && serialNumber && interFaceType) {
			socketClient.emit('resync-admin-data', {
				clientName,
				interFaceType,
				serialNumber
			});
		}
		selectedRowRef.current = null;
	}

	const handleSocketError = ({ message, isRequestFile }) => {
		selectedRowRef.current = null;	
		utils.showError(strings[message] || 'Something Went Wrong', strings.Error, 'error');
		if (isRequestFile) {
			setState({ statusTable: false, confirmTable: false, confirmDialogOpen: false, fileRequestStatus: false, isDisabled: false, deleteProfileStatus: false });
		} else {
			setState({ statusTable: false, confirmTable: false, confirmDialogOpen: false });
		}
	};

	const handleRequestFileSent = () => {
		setState({ statusTable: true });
	}

	const handleDeleteEndoProfileSent = () => {
		setState({ confirmTable: true, isDisabled: true });
	}

	useUniqueEffect(() => {
		if (!socketClient?.connected) {
			socketClient.connect();
		}

		setBreadcrumbs({
			docTitle: strings.EndoProfile,
			breadcrumbs: [{ text: strings.DeleteEndoProfile }],
			actions: [{ component: BackButton }]
		});

		// Register the socket listener
		socketClient.on("request-file", handleRequestFile);
		socketClient.on('delete-endo-profile', handleDeleteEndoProfile);
		socketClient.on('req-file-sent', handleRequestFileSent);
		socketClient.on('delete-all-profile-file-sent', handleDeleteEndoProfileSent);
		socketClient.on('invalid-device-type', handleSocketError);
		socketClient.on('client-not-authorize', handleSocketError);


		// Cleanup to prevent multiple listeners
		return () => {
			socketClient.off('delete-endo-profile');
			socketClient.off('invalid-device-type');
			socketClient.off('client-not-authorize');
			socketClient.off('req-file-sent');
			socketClient.off('delete-all-profile-file-sent');
			socketClient.off("request-file");
		};
	}, []);

	const handleOnCellClick = async ({ field, row }) => {
		if (field === 'ClearAllResync' && selectedRowRef.current?._id !== row._id) {
			socketClient.emit('delete-endo-request', { serialNumber: row.SerialNumber, interFaceType, topic: 'requestfilereq', clientName: row.ClientName });
			selectedRowRef.current = row;
		}
	};
	const handleOnCancel = () => {
		setState({ confirmDialogOpen: true, isDisabled: false });
	};

	const handleCloseConfirmDialog = () => {
		setState({ confirmDialogOpen: false });
	}

	const handleOnContinue = async () => {
		socketClient.emit('delete-endo-request', { clientName: selectedRowRef.current.ClientName, interFaceType, serialNumber: selectedRowRef.current.SerialNumber });
	};

	const handleExit = () => {
		selectedRowRef.current = {};
		setState(initalState);

	}
	return (
		<Grid container>
			<Grid item xs={12} width="100%">
				<HeaderDescription />
				<DeleteResyncDataGird onCellClick={handleOnCellClick} />
			</Grid>
			<Grid item xs={12} width="100%">
				{state.statusTable && <Card>
					<CardContent>
						<Typography gutterBottom sx={{ fontSize: 14 }}>
							{strings.Status}
						</Typography>
						<Typography sx={{ mb: 1.5 }}>{`${strings.RequestFileLabel}: ${state.fileRequestStatus === null ? 'Processing' : state.fileRequestStatus ? 'True' : 'False'}`}</Typography>
						{state.fileRequestStatus === null && <Typography sx={{ mb: 1.5 }}>
							{strings.ProcessNote}
						</Typography>}

						<Typography sx={{ mb: 1.5 }}>{strings.EndoProfileInfoMessage}</Typography>
					</CardContent >
					<CardActions>
						<Button variant="contained" color="success" onClick={handleOnContinue} disabled={(!state.fileRequestStatus || state.isDisabled)}>
							{strings.Continue}
						</Button>
						<Button variant="contained" color="warning" onClick={handleOnCancel} disabled={(!state.fileRequestStatus || state.isDisabled)}>
							{strings.Cancel}
						</Button>
					</CardActions>
				</Card >
				}
				{
					state.confirmTable && <Card sx={{ marginTop: '10px' }}>
						<CardContent>
							<Typography sx={{ mb: 1.5 }}>{`${strings.DeleteAll}: ${state.deleteProfileStatus === null ? 'Processing' : state.deleteProfileStatus ? 'True' : 'False'}`}</Typography>
							{state.deleteProfileStatus === null && <Typography sx={{ mb: 1.5 }}>
								{strings.ProcessNote}
							</Typography>}
							{!state.deleteProfileStatus && <Typography sx={{ mb: 1.5 }}>{strings.EndoProfileConfirmInfoMsg}</Typography>}
						</CardContent>
						<CardActions>
							<Button variant="contained" color="success" onClick={handleExit}>
								{strings.Exit}
							</Button>
						</CardActions>
					</Card>
				}
			</Grid >

			<ConfirmDialog
				title={strings.Cancel}
				body={strings.CancelConfirm}
				open={state.confirmDialogOpen}
				cancelButtonText={strings.Cancel}
				okButtonText={strings.Ok}
				onCancel={handleCloseConfirmDialog}
				onConfirm={() => setState({ statusTable: false, confirmTable: false, confirmDialogOpen: false })}
			/>
		</Grid >
	);
};

export default EndoProfile;